var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentSlash = function SvgDocumentSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    style: {
      enableBackground: "new 0 0 20 20"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.986V7.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 0-.5-.5H4c-.47 0-.904.163-1.245.435L18 13.986ZM2 7.792V18a2 2 0 0 0 2 2h11.734L2 7.792Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13 0 5 5h-4.5a.5.5 0 0 1-.5-.5V0ZM1.664 2.253A1 1 0 1 0 .336 3.747l18 16a1 1 0 0 0 1.328-1.494l-18-16Z"
  })));
};
export default SvgDocumentSlash;